import { SentryLink } from 'apollo-link-sentry';

export const sentryLink = new SentryLink({
	uri: import.meta.env.VITE_ODCO_GRAPHQL_BASE_URL,
	attachBreadcrumbs: {
		includeVariables: true,
		includeError: true
	}
});
